import React from "react";
import { CommunityFeedCommment } from "../../types";
import { CommentEdit } from "..";

type CommentContentProps = {
  commentFeed: CommunityFeedCommment | undefined;
  isEdited: boolean;
  loading: boolean;
  editedComment: any;
  handleUpdateComment: (e: any) => void;
  setEditedComment: React.Dispatch<React.SetStateAction<string | undefined>>;
  openEdit: boolean;
  handleCloseEdit: () => void;
  _image?: string;
};

const CommentContent: React.FC<CommentContentProps> = ({
  commentFeed,
  isEdited,
  setEditedComment,
  loading,
  handleUpdateComment,
  editedComment,
  openEdit,
  handleCloseEdit,
  _image,
}) => {
  const maxLength = 300;
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      {!loading && (
        <div
          className="pr-5 font-Rubik lg:text-sm text-[10px] font-normal w-full block whitespace-pre-line break-words text-justify text-[#646464]"
          key={commentFeed?.id}
        >
          {commentFeed?.comments && commentFeed?.comments.length <= maxLength
            ? commentFeed?.comments
            : isExpanded
            ? commentFeed?.comments
            : commentFeed?.comments?.slice(0, maxLength)}
          {commentFeed?.comments &&
            commentFeed?.comments.length > maxLength && (
              <span
                className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {!isExpanded ? "... See more" : " ... See less"}
              </span>
            )}
          <span className="font-light text-CoolGrey">
            {isEdited && " (edited)"}
          </span>
        </div>
      )}
      {openEdit && (
        <CommentEdit
          userFeed={commentFeed}
          pImage={_image}
          handleUpdateComment={handleUpdateComment}
          handleCloseEdit={handleCloseEdit}
          loading={loading}
          setEditedComment={setEditedComment}
          editedComment={editedComment}
        />
        // <div className="fixed inset-0 w-full z-30 align-middle flex justify-center items-center transition-colors overflow-y-hidden bg-black/20">
        //   <div className="bg-[#FFF] lg:w-[80%] lg:h-[283px] h-[270px] w-[85%] shadow rounded-lg p-8 font-Rubik flex flex-col lg:gap-5">
        //     <div className="flex w-[70%] lg:gap-4 gap-2 h-8 items-center lg:text-base">
        //       <div className="lg:w-8 lg:h-8 w-6 h-6">
        //         {_image ? (
        //           <img
        //             src={ipfsGatewayImage(_image!)}
        //             alt=""
        //             className="lg:w-8 lg:h-8 w-6 h-6 rounded-full"
        //           />
        //         ) : (
        //           <div className="lg:w-8 lg:h-8 w-6 h-6  bg-slate-100 flex items-center justify-center rounded-full">
        //             <CiUser size={15} />
        //           </div>
        //         )}
        //       </div>
        //       <div className=" text-[#01262F] text-xs font-medium">
        //         {`${commentFeed?.creator.firstName} ${commentFeed?.creator.lastName}`}
        //       </div>
        //       <div className=" text-[#646464] text-[10px] font-normal">
        //         {convertTimestamp(commentFeed?.createdAt)}
        //       </div>
        //     </div>
        //     <form
        //       className="w-full flex flex-col gap-5"
        //       onSubmit={handleUpdateComment}
        //     >
        //       <textarea
        //         value={editedComment}
        //         onChange={(e) => setEditedComment(e.target.value)}
        //         rows={4}
        //         className="border border-solid text-pretty border-midGreen j rounded-md px-5 py-3 font-Rubik overflow-auto overscroll-auto resize-none text-sm font-normal outline-none w-full block whitespace-pre-line break-words text-justify text-[#646464]"
        //       />
        //       <div className="flex gap-4 w-[50%]">
        //         <button
        //           type="submit"
        //           className="bg-midGreen capitalize cursor-pointer flex justify-center items-center lg:h-12 h-7 rounded shadow w-[104px] text-white text-xs lg:text-base font-Rubik"
        //           disabled={loading}
        //         >
        //           {loading ? "Updating..." : "Update"}
        //         </button>
        //         <div
        //           className="flex bg-midGreen text-white cursor-pointer justify-center items-center lg:h-12 h-7 w-[104px] rounded shadow text-sm lg:text-base font-Rubik"
        //           onClick={handleCloseEdit}
        //         >
        //           Cancel
        //         </div>
        //       </div>
        //     </form>
        //   </div>
        // </div>
      )}
    </>
  );
};

export default CommentContent;
